import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { RecordsRegisterPage } from "./ui/records-register-page";

export const RecordsRegisterRoute = (...rest: RouteObject[]): RouteObject => {
  return {
    path: routes.general.recordsRegister(),
    element: createElement(RecordsRegisterPage),
    children: [...rest],
  };
};    
